import React, { useState, useEffect } from "react";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { Get_Null_Country_Schools } from "../api/Get_Null_Country_Schools";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  MenuItem,
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  Paper,
  TableBody,
} from "@mui/material";
import { Get_Non_Null_School_Attendees_School_IDS } from "../api/Get_Non_Null_School_Attendees_School_IDS";
import { Search_Hubspot_Company_By_Name } from "../../Schools/api/Search_Hubspot_Company_By_Name";

function AssignSchoolToHubSpot() {
  const { logout } = StaffuseAuth();

  // Assuming Attendee state is fetched from an API using the id
  const [School, setSchool] = useState({});

  useEffect(() => {
    Get_Non_Null_School_Attendees_School_IDS(setSchool, 1, skip, logout);
  }, []);

  //This is the state for the update progress
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleBasicUpdate = (e) => {
    e.preventDefault();
    let id = School._id;
    let data = School;
    delete data._id;
    Update_To_MongoDB_By_ID(
      data,
      "Schools",
      "All_Schools",
      setIsSubmitting,
      id,
      logout
    );
  };

  function handleGetNew(e) {
    e.preventDefault();
    Get_Non_Null_School_Attendees_School_IDS(setSchool, 1, skip, logout);
  }

  const [skip, setSkip] = useState(0);
  const handleSkip = (e) => {
    setSkip(skip + 1);
    handleGetNew(e);
  };

  ////////////////////////////////////////////////////////////////
  //Find HupSpot
  //This is the state for the Hubspot Company
  const [FindHubspotCompany, setFindHubspotCompany] = useState("");
  const [ReturnedHubspotCompanies, setReturnedHubspotCompanies] = useState({
    results: [],
  });

  function handleSerachHubspotForCompany(e) {
    e.preventDefault();
    Search_Hubspot_Company_By_Name(
      FindHubspotCompany,
      setReturnedHubspotCompanies,
      logout
    );
  }

  const ReturnedHubspotCompaniesProps = [
    "name",
    "country",
    "state",
    "city",
    "address",
    "zip",
    "num_associated_contacts",
    "num_associated_notes",
    "num_notes",
    "createdate",
    "hs_lastmodifieddate",
  ];

  function handleHubspotCompanyIDchange(e, value) {
    e.preventDefault();
    setSchool({ ...School, HubspotCompanyID: value });
  }

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        <div style={{ width: "45%" }}>
          <h1>
            Assign a School to a HubSpot Company Account: School Chosen : {skip}
          </h1>
          <p>
            If any Schools do not have a HubSpotID, you can help out here !
            <br></br>
            <br></br>
            Cant find a school? It may not exist in HupSpot yet, so you may need
            to create it!
            <br></br>
            <br></br>
            This page is a little slow, please be patient !.<br></br>
          </p>
          <section>
            {" "}
            <h2>Hubspot</h2>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  key="FindHubspotCompany"
                  name="FindHubspotCompany"
                  label="FindHubspotCompany"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={FindHubspotCompany}
                  onChange={(e) => setFindHubspotCompany(e.target.value)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ mt: 3, ml: 1 }}
                  onClick={(e) => handleSerachHubspotForCompany(e)}
                >
                  Search
                </Button>
              </Grid>{" "}
            </Grid>
            <h3>Hubspot Companies To Assign</h3>
            <Grid container spacing={2}>
              <Box
                component="main"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  maxWidth: "95%",
                  maxHeight: "400px",
                  flexGrow: 1,
                  p: 1,
                  marginLeft: "10px",
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={{
                    width: "100%",
                    margin: "0 auto",
                    overflow: "auto",
                  }}
                >
                  <Table
                    aria-label="simple table"
                    sx={{
                      border: "1px solid #e0e0e0",
                      tableLayout: "fixed",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className="tableCellHeader" // Add this line to include the CSS class
                          align="left"
                          style={{
                            position: "sticky",
                            Top: 0,
                            zIndex: 1,
                            fontWeight: "bold", // Make Text bold
                            padding: "8px", // Adjust padding as needed To make cells smaller
                          }}
                        >
                          id
                        </TableCell>
                        {ReturnedHubspotCompaniesProps.map((prop) => (
                          <TableCell
                            className="tableCellHeader" // Add this line to include the CSS class
                            align="left"
                            style={{
                              position: "sticky",
                              Top: 0,
                              zIndex: 1,
                              fontWeight: "bold", // Make Text bold
                              padding: "8px", // Adjust padding as needed To make cells smaller
                            }}
                          >
                            {prop}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ReturnedHubspotCompanies.results.map(
                        (ReturnedHubspotCompany, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:hover": {
                                backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                                "& .MuiTableCell-root": {
                                  padding: "8px",
                                  wordWrap: "break-word",
                                  overflowWrap: "break-word", // Adjust padding here to make cells smaller
                                },
                              },
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                wordBreak: "break-all",
                              }}
                            >
                              {ReturnedHubspotCompany.id
                                ? ReturnedHubspotCompany.id
                                : ""}
                            </TableCell>
                            {ReturnedHubspotCompaniesProps.map((prop) => (
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "8px",
                                  wordWrap: "break-word",
                                  overflowWrap: "break-word",
                                }}
                              >
                                {ReturnedHubspotCompany.properties &&
                                ReturnedHubspotCompany.properties[prop]
                                  ? ReturnedHubspotCompany.properties[prop]
                                  : ""}
                              </TableCell>
                            ))}
                            <Button
                              type="submit"
                              variant="contained"
                              sx={{ mt: 3, ml: 1 }}
                              onClick={(e) =>
                                handleHubspotCompanyIDchange(
                                  e,
                                  ReturnedHubspotCompany.id
                                )
                              }
                            >
                              Assign
                            </Button>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </section>
        </div>
        {School.School_Name && School.School_Name !== "" ? (
          <div style={{ width: "45%" }}>
            <h1>Info:</h1>
            <h2> Name: {School.School_Name}</h2>
            <h2> Country: {School.School_Country}</h2>
            <h2> PostCode: {School.School_PostCode}</h2>
            <h2> Region: {School.School_Region}</h2>
            <h2> Type: {School.School_Type}</h2>
            <h2> HubSpotID: {School.HubspotCompanyID}</h2>
            <br></br>
            <h2> School _id: {School._id}</h2>

            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, ml: 1 }}
              disabled={
                isSubmitting ||
                School.HubspotCompanyID === "" ||
                !School.HubspotCompanyID
              }
              style={{ backgroundColor: "green" }}
              onClick={(e) => handleBasicUpdate(e)}
            >
              {isSubmitting ? "Submitting..." : "Update School"}
            </Button>

            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 3, ml: 1 }}
              onClick={(e) => handleSkip(e)}
            >
              {isSubmitting ? "Submitting..." : "Get Next/Skip School"}
            </Button>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default AssignSchoolToHubSpot;
